export const animateSorted = (bar) => {
  const color = "rgb(85,255,51)";
  bar.style.backgroundColor = color;
};
